import { render, staticRenderFns } from "./pText.vue?vue&type=template&id=6a781459&"
import script from "./pText.vue?vue&type=script&async=true&lang=js&"
export * from "./pText.vue?vue&type=script&async=true&lang=js&"
import style0 from "./pText.vue?vue&type=style&index=0&id=6a781459&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports